export default __webpack_public_path__ + "static/media/light-bulb.03c0c26d.svg";